// noinspection JSUnusedGlobalSymbols
export default function() {
    $(function () {

        //get translated warning from hidden field if available
        let errorText = <string>$("input[name='go-away-warning']").val();
        if (errorText.length === 0) {
            errorText = 'Please cancel this operation, so the survey can be completed without errors! IMPORTANT: Please, stay on this page!';
        }

        function confirmBrowseAway(): string | void {
            if ((<any>window).showConfirmBrowseAway) {
                return errorText;
            }
        }

        (<any>window).showConfirmBrowseAway = true;
        window.onbeforeunload = confirmBrowseAway;

        // Disable browse away warning for elements with data-disable-browse-away-warning="1"
        $(document).find('[data-disable-browse-away-warning="1"]').on('click', function () {
            (<any>window).showConfirmBrowseAway = false;
        });
    });
}